const keys = {
  carDetails: {
    actions: {
      add: 'Add Car',
      edit: 'Edit',
      remove: 'Remove',
    },
    choices: {
      commuteDetails: {
        pleasure: 'Pleasure',
        school: 'Commuting to school',
        work: 'Commuting to work',
      },
      conditionAtPurchase: {
        demo: 'Demo',
        new: 'New',
        used: 'Used',
      },
      paymentStatus: {
        financed: 'Financed',
        leased: 'Leased',
        paid: 'Paid',
      },
    },
    fields: {
      carDescription: {
        make: 'Make',
        model: 'Model',
        modelYear: 'Year',
      },
      commuteDetails: 'Primary usage of the car',
      conditionAtPurchase: 'Condition of the car when you bought it',
      dailyKilometers: 'Average kilometers driven per day',
      kmOnOdometer: 'Kilometers on the odometer when it was purchased',
      paymentStatus: 'Payment status on the car',
      possessionDate: 'Acquisition date of the car',
      security: 'Security systems installed on the car',
      winterTires: 'Do you have winter tires for your vehicle?',
      yearlyKilometers: 'Average kilometers driven per year',
      yearlyDaysOutsideOfProvince: 'Average number of weeks per year driven outside of your home province',
    },
    helpers: {
      possessionDate: 'This is the date the car registration was transferred to you.',
      dailyKilometers: 'Canadians drive 20km per day on average',
      security: 'Inaccurate information can affect a future claim',
      winterTires: 'Save up to $100 on your premium with winter tires.',
      yearlyKilometers: 'Canadians drive 15-20,000km per year on average',
    },
    kilometers: 'Km',
    noOptionMessage: {
      carDescription: {
        selectMake: 'Please select a make first',
        selectModelYear: 'Please select a model year first',
      },
    },
    placeholders: {
      carDescription: {
        make: 'ex. Hyundai',
        model: 'ex. Accent Essential 4DR',
        modelYear: 'ex. 2019',
      },
      dailyKilometers: 'ex. 15',
      kmOnOdometer: 'ex. 5',
      yearlyKilometers: 'ex. 20',
      yearlyDaysOutsideOfProvince: 'ex. Never',
    },
    subtitle: 'You must be a registered owner of at least one of the vehicles.',
    title: 'Add all your cars here.',
  },
};

export default keys;

export type TranslationKeys = typeof keys;
